import { AddressInput } from "../search/AddressInput";
var FrontForm = /** @class */ (function () {
    function FrontForm() {
        this.addressInput = new AddressInput();
    }
    return FrontForm;
}());
export default FrontForm;
